/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ClusterInfraStateEnum } from './ClusterInfraStateEnum';
import {
    ClusterInfraStateEnumFromJSON,
    ClusterInfraStateEnumFromJSONTyped,
    ClusterInfraStateEnumToJSON,
} from './ClusterInfraStateEnum';

/**
 * Cluster Infra state model.
 * @export
 * @interface ClusterInfraState
 */
export interface ClusterInfraState {
    /**
     * 
     * @type {number}
     * @memberof ClusterInfraState
     */
    id: number;
    /**
     * 
     * @type {ClusterInfraStateEnum}
     * @memberof ClusterInfraState
     */
    state: ClusterInfraStateEnum;
    /**
     * 
     * @type {string}
     * @memberof ClusterInfraState
     */
    reason: string;
}

/**
 * Check if a given object implements the ClusterInfraState interface.
 */
export function instanceOfClusterInfraState(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "state" in value;
    isInstance = isInstance && "reason" in value;

    return isInstance;
}

export function ClusterInfraStateFromJSON(json: any): ClusterInfraState {
    return ClusterInfraStateFromJSONTyped(json, false);
}

export function ClusterInfraStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClusterInfraState {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'state': ClusterInfraStateEnumFromJSON(json['state']),
        'reason': json['reason'],
    };
}

export function ClusterInfraStateToJSON(value?: ClusterInfraState | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'state': ClusterInfraStateEnumToJSON(value.state),
        'reason': value.reason,
    };
}

